import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useUserByIdQuery } from "generated/graphql";
import { LoadingIndicator, PolyIcon } from "elements";
import { Link } from "polyrouter";
import { useTranslation } from "utilities/i18n";
import { useLogout } from "auth";

const useUser = () => {
  const { user } = useAuth0();
  const query = useUserByIdQuery({
    variables: {
      id: user ? user.sub : ""
    }
  });
  return { user, ...query };
};

export const ImportLoginCheck: React.FC<{
  cancelURL: string;
}> = ({ cancelURL, children }) => {
  const { data, fetching } = useUser();

  const hasMicrosoftIdentity =
    data?.user?.user?.identities?.find(
      identity => identity?.connection === "Microsoft"
    ) !== undefined;

  const { t } = useTranslation();
  const logout = useLogout();

  return (
    <>
      {fetching && <LoadingIndicator />}
      {!hasMicrosoftIdentity && (
        <>
          {!fetching && <p>{t("IMPORT_USER_GROUPS_MICROSOFT_LOGIN_PROMPT")}</p>}
          <div className={`btn-container`}>
            <Link to={cancelURL} className="btn">
              {t("CANCEL")}
            </Link>
            {!fetching && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => logout()}
              >
                <PolyIcon icon="clear_circle_outline" className="white mr-5" />
                {t("SIGN_OUT")}
              </button>
            )}
          </div>
        </>
      )}
      {hasMicrosoftIdentity && children}
    </>
  );
};
